'use client'

import { parseStaticMetadata } from "@/src/function/parser"
import { getDictionary } from "@/app/[lang]/locales"
import Link from "next/link"

import Image from "next/image"
import { useEffect, useRef } from "react"

/**
 * Ce script charge le composant nécessaire en fonction de l'URL et de la langue.
 * 
 * Il fonctionne pour toute les page "dyanmique" et "statique" présente dans la base de donnée
 * 
 * Voire la doc de NextJS concernant les routes dynamique : https://nextjs.org/docs/app/building-your-application/routing/dynamic-routes
 * 
 *  
 * @param {Object} parametter
 * @param {object} parametter.params - Une promesse qui se résout en un objet contenant les paramètres de route dynamiques, depuis le segment racine jusqu'à cette mise en page.
 * */ 
export async function generateMetadata({params}) {
    const {lang} = await params
    return parseStaticMetadata((await getDictionary(lang)).metadata.home)
}


/**
 * Retourne la titre de la page d'acceui
 * @returns 
 */
export default function TitleBloc({local,events,lang}) {
    const video = useRef(null)
    useEffect(()=>{
        if(video.current) {
            video.current.play().catch((err) => {
            console.warn('Autoplay bloqué :', err);
            })
        }
    },[])

    const getEventURL = (id)=>{
        const event = events.find((e)=>e.id==id)
        return `/${lang}/${local.staticPage.agenda}/${id}/${event?.titre[lang]}`
    }
    return(
        <div className="md:flex relative justify-between title-bloc h-screen">

            <div className=" md:pl-20 absolute z-10 flex flex-col h-full top-0 w-full video-homepage-filter">
                <div className="my-auto mx-auto md:mx-0">
                    <h1 className="md:text-[4vw] text-4xl mb-4 md:text-left text-center ubuntu  md:mb-4 font-bold text-white 2xl:leading-[100px] lg:leading-[80px] sm:leading-[60px]">The only<br/>Belgian military<br/>university.</h1>
                    <h2 className="md:text-[2vw] lora md:text-left text-center text-xl text-white mb-12">Rege duce pro jure et honore </h2>
                    <button className="hidden large-button button-Young mx-auto md:mx-0" onClick={()=>location=getEventURL(33)}>{local.discoveryDay.callToAction}</button>
                </div>
            </div>
            
            <video autoPlay muted loop playsInline id="background-video" className="object-cover size-full">
                <source src="/Homepage/rma_tour_video.mp4" type="video/mp4"/>
            </video>


            
        </div>
    )
}